import classnames from 'classnames';
import {getImage, GatsbyImage} from 'gatsby-plugin-image';
import React from 'react';
import {graphql, useStaticQuery} from 'gatsby';
import './SnakeModule.less';
import {ImageModuleProps} from '../include/Types';

interface SnakeModuleProps extends ImageModuleProps {
  layout?: 'ImageLeft' | 'ImageRight';
  imageSize?: 'Medium' | 'Large';
  forceAltBackground?: 'On' | 'Off';
  anchorName?: string;
}

const SnakeModule: React.FC<SnakeModuleProps> = ({
  className,
  title,
  children,
  imageName,
  imageAlt,
  layout,
  imageSize,
  forceAltBackground,
  anchorName,
}) => {
  const qResult = useStaticQuery(graphql`
    query {
      allFile(filter: {sourceInstanceName: {eq: "images"}}) {
        nodes {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
          name
        }
      }
    }
  `);

  const imageData =
    imageName && getImage(qResult.allFile.nodes.find((node: Record<any, any>) => node.name === imageName));

  return (
    <div
      className={classnames(
        'Module',
        `SnakeModule`,
        layout || 'ImageRight',
        imageSize && `Image${imageSize}`,
        {AltBgOn: forceAltBackground === 'On'},
        {AltBgOff: forceAltBackground === 'Off'},
        className
      )}
    >
      <div className={classnames('ModuleContent', 'BodyLarge')} id={anchorName}>
        {imageData && <GatsbyImage image={imageData} alt={imageAlt || 'Hero image'} />}
        <div className="SnakeContent">
          {title && <h2>{title}</h2>}
          {children}
        </div>
      </div>
    </div>
  );
};

export default SnakeModule;
